export enum EngineeringDashboardEnum {
    MODULE_ACCESS = 'View',
    FILTER_BY_VIEW = 'Filter_by_View',
    FILTER_BY_EDIT = 'Filter_by_Edit',
    CREATE_SIGNOFF = 'Create_Signoff',
    INVALIDATE_SIGNOFF = 'Invalidate_Signoff',
    LINK_SIGNOFF = 'Link_Signoff',
    ENGINEERING_DASHBOARD_GRID_VIEW = 'Engineering_Dashboard_Grid_View',
    ENGINEERING_DASHBOARD_GRID_EDIT = 'Engineering_Dashboard_Grid_Edit',
}
